export default __webpack_public_path__ + "static/media/solana.7b25ef17.svg";